module.exports = __webpack_public_path__ + "img/27.91483205.jpg";